<div [style]="reportImageStyle"
  [style.top]="reportImage.top" [style.left]="reportImage.left" [style.width]="reportImage.width"
  [style.height]="reportImage.height" (click)="onClick($event)">
  <img *ngIf="reportImage?.src" [src]="getImageUrl(reportImage.src)"
    [style.width]="reportImage.width" [style.height]="reportImage.height"
    [style.z-index]="reportImage.zIndex">
</div>
